export const AUTHORIZED_LAYOUT_TYPE = {
    PORTAL: 1,
    CUSTOMIZE: 2,
    GUIDE: 3
}